"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = void 0;
function shouldPolyfill() {
    return !Intl.Segmenter;
}
exports.shouldPolyfill = shouldPolyfill;
